import React from 'react';
import { Divider as AntDivider } from 'antd';

export const Divider = (props) => (
    <AntDivider {...props} />
);
